/* import __COLOCATED_TEMPLATE__ from './learning-material-uploader.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import readableFileSize from 'ilios-common/utils/readable-file-size';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
let LearningMaterialUploaderComponent = (_class = class LearningMaterialUploaderComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "fetch", _descriptor, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "fileQueue", _descriptor4, this);
    _defineProperty(this, "uploadQueueName", 'materials');
    _initializerDefineProperty(this, "fileUploadErrorMessage", _descriptor5, this);
    _defineProperty(this, "upload", _buildTask(() => ({
      context: this,
      generator: function* (file) {
        this.args.setFilename(null);
        this.args.setFileHash(null);
        this.fileUploadErrorMessage = false;
        const maxUploadSize = yield this.iliosConfig.getMaxUploadSize();
        if (file.size > maxUploadSize) {
          const maxSize = readableFileSize(maxUploadSize);
          this.fileUploadErrorMessage = this.intl.t('general.fileSizeError', {
            maxSize
          });
          const queue = this.fileQueue.find(this.uploadQueueName);
          queue.files.splice(queue.files.indexOf(file), 1);
          return false;
        }
        const response = yield file.upload(`${this.fetch.host}/upload`, {
          headers: this.fetch.authHeaders
        });
        if (response.status === 200) {
          const {
            filename,
            fileHash
          } = yield response.json();
          this.args.setFilename(filename);
          this.args.setFileHash(fileHash);
          return filename;
        }
        return false;
      }
    }), null, "upload", "drop"));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetch", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "fileQueue", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "fileUploadErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { LearningMaterialUploaderComponent as default };